import { ContentBlockDefinition } from '@/core/block-registry';
import type { Ref } from 'vue';
import type { ContentBlock } from '@/modules/content-blocks/interfaces';

export const BlockEditProps = {
   editingBlock: {
      type: Object as PropType<Ref<ContentBlock | null>>,
      required: true,
   },
   editingBlockDefinition: {
      type: Object as PropType<Ref<ContentBlockDefinition | null | undefined>>,
      required: true,
   },
   draftData: {
      type: Object as PropType<Ref<Record<string, any> | null>>,
      required: true,
   },
};
